import styled from "styled-components";

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  gap: 20px;
  overflow-y: overlay;
  max-height: 70vh;

  &::-webkit-scrollbar {
    width: 0px;
  }

  h2 {
    font-size: 16px;
    font-weight: 600;
    color: #333333;
  }
`;

export const Row = styled.div<{ template?: string }>`
  display: grid;
  grid-template-columns: ${({ template }) => template ?? "1fr 1fr"};
  gap: 20px;
`;

export const Field = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  p {
    font-size: 14px;
    font-weight: 500;
    color: #424248;
    span {
      color: red;
    }
  }
`;
